import paymentMethods from './Payment'

export const PaymentServices = {
  ...paymentMethods
}

export * from './Payment.types'
